import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, PRIMARY_OUTLET } from '@angular/router';
import { filter } from 'rxjs/operators';
import { NgxBreadcrumbsService } from 'ng8-breadcrumbs';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from './service/authentication-service.service';
import { Staff } from './entity/Staff';
export interface BreadCrumb {
  label: string;
  url: string;
};

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'ErpAngular';
  public breadcrumbs: Breadcrumb[];

 staff:Staff;
 roles:string;
  show: boolean = false;
 
idUserCrypted
idUser:number
  constructor(private router: Router, private route: ActivatedRoute,private breadcrumbService: NgxBreadcrumbsService ,
    private authService:AuthenticationService) {
 
  }



  ngOnInit() {
    


this.authService.currentUserObserve.subscribe(val => {
  this.staff=val;
  this.idUser=null;
  this.idUserCrypted=null;

  if(this.staff){
    this.roles=this.staff.roleUser;
    this.idUser=  +localStorage.getItem("idUser") 
  this.idUserCrypted=  +localStorage.getItem("idUser")*9555  

 //this.router.navigateByUrl('/client-list/CLIENTS/'+this.idUserCrypted)
 
  }

});


 

  let breadcrumb: Breadcrumb = {
    label: 'Home',
    url: ''
  };

  this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
    //set breadcrumbs
    let root: ActivatedRoute = this.route.root;
    this.breadcrumbs = this.getBreadcrumbs(root);
     this.breadcrumbs = [breadcrumb, ...this.breadcrumbs];
     
  });

}


private getBreadcrumbs(route: ActivatedRoute, url: string = "", breadcrumbs: Breadcrumb[] = []): Breadcrumb[] {
  const ROUTE_DATA_BREADCRUMB: string = "breadcrumb";
///debugger
  //get the child routes
  let children: ActivatedRoute[] = route.children;

  //return if there are no more children
  if (children.length === 0) {
    return breadcrumbs;
  }

  //iterate over each children
  for (let child of children) {
    //verify primary route
    if (child.outlet !== PRIMARY_OUTLET || child.snapshot.url.length==0) {
      continue;
    }

    //verify the custom data property "breadcrumb" is specified on the route
    if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
      return this.getBreadcrumbs(child, url, breadcrumbs);
    }

    //get the route's URL segment
    let routeURL: string = child.snapshot.url.map(segment => segment.path).join("/");

    //append route URL to URL
    url += `/${routeURL}`;

    //add breadcrumb
    let breadcrumb: Breadcrumb = {
      label: child.snapshot.data[ROUTE_DATA_BREADCRUMB],
      url: url
    };
    breadcrumbs.push(breadcrumb);

    //recursive
    return this.getBreadcrumbs(child, url, breadcrumbs);
  }
  return breadcrumbs;
}



logout(){
this.authService.logout()
this.router.navigate(['/login']  );
}



 gotoClient(type:string){
  window.open(
    environment.serverAdresse+'/add-client/'+this.idUserCrypted );
  
  }
  
 gotoProspect(){
  window.open(
    environment.erpAdresse+'/#/loginid/'+this.idUserCrypted ,'_self');
 }
 gotoFinance(){
  window.open(
    environment.serverFinanceAdresse+'/loginid/'+this.idUserCrypted ,'_self');
 }
 gotoFloorPlan(){
  window.open('http://admin-pc:8080/NAPEC2020/floorv.xhtml','_blank');
 }


 }

 
 export interface Breadcrumb{
  label: string;
    url: string;
  }
 